import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { SalesOrderPL, TeamMember } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 1261. 受注案件収支取得
 * [GET] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/pl
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
};
const salesOrderPL = (props: Props): Promise<SalesOrderPL> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.id}/pl`);
};

export const useSalesOrderPL = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => salesOrderPL(props),
  });
};

export const useInvalidateSalesOrderPL = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'teams', props.team_id, 'sales_orders', props.id, 'pl'];
};
